module.exports=/[\0-\x1F\x7F-\x9F]/


/*****************
 ** WEBPACK FOOTER
 ** ../~/markdown-it/~/uc.micro/categories/Cc/regex.js
 ** module id = 245
 ** module chunks = 1
 **/